export const olHeaders = {
  'x-http-caller-id': 'field-view',
  'x-http-caller-version': process.env.version || '1.0',
};